import Vue from 'vue'

const loggerPlugin = {
  install() {
    Vue.prototype.$logger = (message, severity) => {
      if (severity == 'warning') {
        console.warn(message)
      } else if (severity == 'debug') {
        console.debug(message)
      } else if (severity == 'error') {
        console.error(message)
      } else if (severity == 'info') {
        console.info(message)
      } else {
        console.log(message)
      }
    }
  }
}

export default loggerPlugin
